<template>
    <div class="notification"
        @click="$emit('click')">

        <div class="relative pr-6">
            <h3 class="font-normal mb-2">{{ notification.subject }}</h3>
            <p class="text-60">{{ $du(notification.created_at, 'shortDateTime') }}</p>

            <div v-if="!notification.read_at">
                <div
                    class="w-4 h-4 rounded-full bg-primary absolute"
                    style="right:0; top:50%; margin-top: -0.5rem;">
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {

    props: {
        notification: {
            type: Object,
            required: true,
        },
    },
};
</script>
